<template>
  <game-template title="Regardez attentivement la vidéo">
    <template v-slot:content>
      <div class="video-step-content">
        <div class="video-wrapper">
          <iframe id="kaltura_player" src="https://cdnapisec.kaltura.com/p/387001/sp/38700100/embedIframeJs/uiconf_id/39074502/partner_id/387001?iframeembed=true&playerId=kaltura_player&entry_id=1_42cv0o1q&flashvars[streamerType]=auto&amp;flashvars[localizationCode]=en&amp;flashvars[leadWithHTML5]=true&amp;flashvars[sideBarContainer.plugin]=true&amp;flashvars[sideBarContainer.position]=left&amp;flashvars[sideBarContainer.clickToClose]=true&amp;flashvars[chapters.plugin]=true&amp;flashvars[chapters.layout]=vertical&amp;flashvars[chapters.thumbnailRotator]=false&amp;flashvars[streamSelector.plugin]=true&amp;flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&amp;flashvars[dualScreen.plugin]=true&amp;flashvars[hotspots.plugin]=1&amp;flashvars[Kaltura.addCrossoriginToIframe]=true&amp;&wid=1_w24why9o" width="608" height="402" allowfullscreen webkitallowfullscreen mozAllowFullScreen allow="autoplay *; fullscreen *; encrypted-media *" sandbox="allow-forms allow-same-origin allow-scripts allow-top-navigation allow-pointer-lock allow-popups allow-modals allow-orientation-lock allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation" frameborder="0" title="Kaltura Player"></iframe>
        </div>
        <p class="annotation">Vous pouvez mettre la vidéo en plein écran</p>
        <p class="text">
          Vous avez bien identifié les étapes de la déclaration de paiement ?
        </p>
        <button class="button" @click="next">
          Saisir les paiements
        </button>
      </div>
    </template>
  </game-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'

export default {
  name: 'VideoStep',
  mixins: [stepMixin]
}
</script>

<style lang="scss">
.video-step-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .video-wrapper {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 402px;
    iframe {
      width: 608px;
      height: 402px;
    }
  }
  .annotation {
    margin-top: 5px;
    font-style: italic;
    color: $light-text-color;
    font-size: 0.9rem;
  }
  .text {
    margin-top: 40px;
    margin-bottom: 20px;
    font-weight: 700;
    font-size: 1.3rem;
  }
}
</style>
